import { useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';
import { setInternalAnalyticsExcluded } from '../utils/siteAnalytics';

/**
 * Sätter sessionStorage-flagga när inloggad admin surfar publika sidor,
 * så first-party analytics och dataLayer inte spårar intern testtrafik.
 */
export default function InternalAnalyticsGuard() {
  useEffect(() => {
    let cancelled = false;

    const syncAdminExclude = async (hasSession: boolean) => {
      if (!hasSession) {
        setInternalAnalyticsExcluded(false);
        return;
      }

      try {
        const { data: isAdmin, error } = await supabase.rpc('is_admin');
        if (cancelled) return;
        if (error) {
          console.warn('[InternalAnalyticsGuard] is_admin failed:', error.message);
          setInternalAnalyticsExcluded(false);
          return;
        }
        setInternalAnalyticsExcluded(Boolean(isAdmin));
      } catch (e) {
        if (!cancelled) {
          console.warn('[InternalAnalyticsGuard] sync failed', e);
          setInternalAnalyticsExcluded(false);
        }
      }
    };

    void supabase.auth.getSession().then(({ data: { session } }) => {
      void syncAdminExclude(Boolean(session));
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      void syncAdminExclude(Boolean(session));
    });

    return () => {
      cancelled = true;
      subscription.unsubscribe();
    };
  }, []);

  return null;
}
